/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B3_TInputs */

const en_mk_abt_b3_t = /** @type {(inputs: Mk_Abt_B3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost must be visible`)
};

const id_mk_abt_b3_t = /** @type {(inputs: Mk_Abt_B3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya harus terlihat`)
};

/**
* | output |
* | --- |
* | "Cost must be visible" |
*
* @param {Mk_Abt_B3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b3_t = /** @type {((inputs?: Mk_Abt_B3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b3_t(inputs)
	return en_mk_abt_b3_t(inputs)
});